import { createContext, useContext, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { LeadForm } from "../components/LeadForm";
import { useLang } from "./LanguageContext";
import { track } from "../lib/tracking";

const LeadDialogContext = createContext(null);

export function LeadDialogProvider({ children }) {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const [ctx, setCtx] = useState({ course: null, source: "landing", simplified: false });

  const openLead = (course = null, source = "landing", simplified = false) => {
    setCtx({ course, source, simplified });
    setOpen(true);
    track("click_richiedi_informazioni", { course: course?.title || "", source });
  };

  return (
    <LeadDialogContext.Provider value={{ openLead }}>
      {children}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          data-testid="lead-dialog"
          className="max-w-xl bg-[#F4F8FF] border-[#D5DEEE] max-h-[92vh] overflow-y-auto"
        >
          <DialogHeader>
            <DialogTitle className="font-heading text-3xl font-light text-left">
              {t("dialog.info_title")}
            </DialogTitle>
            <DialogDescription className="text-sm text-[#5C6678] text-left font-light">
              {t("dialog.info_sub")}
            </DialogDescription>
          </DialogHeader>
          <LeadForm course={ctx.course} source={ctx.source} simplified={ctx.simplified} />
        </DialogContent>
      </Dialog>
    </LeadDialogContext.Provider>
  );
}

export const useLeadDialog = () => useContext(LeadDialogContext);
